/** Grey: the colour of "Other", once the six first colours are taken. */
export const SEGMENT_GREY = '#71717a';

/**
 * The colours the segment editor offers (SEG-1…3); the team can also pick any other.
 * The first six are the ones new segments get in turn, as the backend gives them
 * (`segSlotColors` in backend/pkg/api/segments.go). All but yellow are deep enough
 * for white text on a tag (textOn, src/utils/color.ts).
 */
export const SEGMENT_COLORS = [
  { value: '#2a78d6', label: 'Blue' },
  { value: '#d95926', label: 'Orange' },
  { value: '#199e70', label: 'Green' },
  { value: '#c27803', label: 'Amber' },
  { value: '#d55181', label: 'Pink' },
  { value: '#6250d6', label: 'Violet' },
  { value: '#0f8b8d', label: 'Teal' },
  { value: '#dc2626', label: 'Red' },
  { value: '#facc15', label: 'Yellow' },
  { value: SEGMENT_GREY, label: 'Grey' },
];

/** The colour a new segment starts with: its slot's (1–6), or grey for slot 0. */
export const slotColor = (slot: number) => (slot >= 1 && slot <= 6 ? SEGMENT_COLORS[slot - 1].value : SEGMENT_GREY);
